import BreadCrumb from "Components/Common/BreadCrumb";
import Loader from "Components/Common/Loader";
import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import React, { useEffect, useState } from "react";
import { Button, Container, Row, Table } from "reactstrap";
import { createSelector } from "reselect";
import { selectNotificationsState } from "slices/notifications/reducer";
import { getNotifications } from "slices/thunks";
import { getPageNumbers, timeFromNow } from "utils/utils";

const Notifications = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch: any = useAppDispatch();
  const notificationSelector = createSelector(
    selectNotificationsState,
    (state) => ({
      notifications: state.notifications,
      isLoading: state.status.fetch,
      meta: state.pagination,
    }),
  );

  const { notifications, isLoading, meta } =
    useAppSelector(notificationSelector);

  const onPageChange = (page: number) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    dispatch(getNotifications({ page: currentPage }));
  }, [dispatch, currentPage]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Notifications"
          pageTitle="Dashboard"
          url="/dashboard"
        />

        <div className="d-flex flex-column  bg-white rounded shadow-sm p-3 ">
          {notifications.map((item, index) => (
            <React.Fragment key={index}>
              <div className="d-flex justify-content-between align-items-center">
                <p className="text-black2D font-primary fw-normal fs-16">
                  {item.message}
                </p>
                <p className="text-grey89 font-primary fw-normal fs-12">
                  {timeFromNow(item.created_at)}
                </p>
              </div>
              {index !== notifications.length - 1 && (
                <div className="border-bottom w-100 mb-3" />
              )}
            </React.Fragment>
          ))}
          {isLoading === "loading" && notifications.length === 0 && (
            <Loader error={null} />
          )}
          {notifications && notifications.length > 0 ? (
            <Row className="align-items-center mt-2 g-3 text-center text-sm-start">
              <div className="col-sm">
                <div className="text-muted">
                  Showing
                  <span className="fw-semibold ms-1">{meta?.to}</span> of{" "}
                  <span className="fw-semibold">{meta.total}</span> Results
                </div>
              </div>
              <div className="col-sm-auto">
                <ul className="pagination pagination-separated pagination-md justify-content-center justify-content-sm-start mb-0">
                  {/* Previous */}
                  <li
                    className={
                      currentPage === 1 ? "page-item disabled" : "page-item"
                    }
                  >
                    <Button
                      className="page-link fs-14 text-grey89 fw-normal br-4"
                      onClick={(e) => {
                        e.preventDefault();
                        (currentPage || 1) > 1 &&
                          onPageChange?.((currentPage || 1) - 1);
                      }}
                    >
                      Previous
                    </Button>
                  </li>

                  {/* Dynamic Pages */}
                  {getPageNumbers(currentPage || 1, meta?.last_page || 1).map(
                    (p, index) => (
                      <li
                        key={index}
                        className={`page-item ${
                          p === currentPage ? "active" : ""
                        } ${p === "..." ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault();
                            if (p !== "..." && onPageChange) {
                              onPageChange(Number(p));
                            }
                          }}
                        >
                          {p}
                        </button>
                      </li>
                    ),
                  )}

                  {/* Next */}
                  <li
                    className={
                      currentPage === meta?.last_page
                        ? "page-item disabled"
                        : "page-item"
                    }
                  >
                    <button
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        (currentPage || 1) < (meta?.last_page || 1) &&
                          onPageChange?.((currentPage || 1) + 1);
                      }}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </div>
            </Row>
          ) : (
            <div className="table-responsive table-card mb-2 mt-2 bg-white">
              <Table hover className="table-bordered m-0">
                <tbody>
                  <tr>
                    <td className="text-center d-flex justify-content-center align-items-center">
                      <p className="m-0 text-black2D fs-14 fw-normal font-primary">
                        No results found
                      </p>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default React.memo(Notifications);
